import React, { useRef } from "react";
import { motion, useAnimation, useInView } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { HeroSection, HeroContent, HeroText } from "./HeroStyles";
import { editAttr } from "../../sanity/editAttr";

const fadeInUp = { hidden: { opacity: 0, y: 30 }, visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } } };
const staggerContainer = { hidden: { opacity: 0 }, visible: { opacity: 1, transition: { staggerChildren: 0.2, delayChildren: 0.1 } } };

export default function Hero({ data = {}, documentId, sectionKey }) {
  const { heading = "", body = "", ctaLabel = "Contact Us", ctaLink = "/contact-us" } = data;
  const heroRef = useRef(null);
  const heroControls = useAnimation();
  const heroInView = useInView(heroRef, { once: true });

  React.useEffect(() => {
    if (heroInView) heroControls.start("visible");
  }, [heroInView, heroControls]);

  const base = `sections[_key=="${sectionKey}"]`;

  return (
    <HeroSection id="hero-section" ref={heroRef}>
      <HeroContent>
        <HeroText>
          <motion.div initial="hidden" animate={heroControls} variants={staggerContainer}>
            <motion.h1 variants={fadeInUp} {...editAttr(documentId, `${base}.heading`)}>
              {heading}
            </motion.h1>
            <motion.p variants={fadeInUp} {...editAttr(documentId, `${base}.body`)}>
              {body}
            </motion.p>
            <motion.div variants={fadeInUp}>
              <Link to={ctaLink}>
                <button {...editAttr(documentId, `${base}.ctaLabel`)}>
                  {ctaLabel}
                  <div className="arrow-container">
                    <ArrowUpRight size={20} />
                  </div>
                </button>
              </Link>
            </motion.div>
          </motion.div>
        </HeroText>
      </HeroContent>
    </HeroSection>
  );
}
